import { ServiceMaker, methods, services } from "@/services";
export const listsubcategory = (id) =>
  ServiceMaker(
    `/servicerequest/category/list?parent=${id}`,
    methods.GET,
    services.master
  );

export const listservicerequest = () =>
  ServiceMaker(`/servicerequest/category/list`, methods.GET, services.master);

export const createRequest = (data) =>
  ServiceMaker(
    `/servicerequest/category/create`,
    methods.POST,
    services.master,
    data
  );

export const updateCategory = (id, data) =>
  ServiceMaker(
    `/servicerequest/category/update/${id}`,
    methods.PUT,
    services.master,
    data
  );

export const deleteRequest = (id) =>
  ServiceMaker(
    `/servicerequest/category/delete/${id}`,
    methods.DELETE,
    services.master
  );

export const createSubcategory = (data) =>
  ServiceMaker(
    `/servicerequest/category/create`,
    methods.POST,
    services.master,
    data
  );
